// extracted by mini-css-extract-plugin
export default {"cardPhotoMain":"AAm8fjg2","mobile":"PLw2Zrto","link":"W8W653SV","info":"AX4eyDLw","headline":"BhtdXLtJ","date":"c7UN2VdT","type":"VQ0U8TtU"};